import { forwardRef, ReactNode } from 'react'
import {
  Flex,
  Box,
  BoxProps,
  Input as ThemeUIInput,
  InputProps as ThemeUIInputProps,
  ThemeUIStyleObject,
} from 'theme-ui'

export type InputProps = ThemeUIInputProps & {}

export type InputWithAdornmentProps = ThemeUIInputProps & {
  before?: ReactNode
  after?: ReactNode
  isBeforeClickable?: boolean
  isAfterClickable?: boolean
}

type AdornmentProps = BoxProps & {
  children: ReactNode
  isClickable: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ ...rest }, ref) => {
    const styleSx: ThemeUIStyleObject = rest.sx ?? {}
    return <ThemeUIInput ref={ref as any} sx={styleSx} {...rest} />
  }
)

const Adornment = ({ children, isClickable, ...rest }: AdornmentProps) => (
  <Box
    sx={{
      position: 'absolute',
      pointerEvents: isClickable ? 'all' : 'none',
      ...rest.sx,
    }}
  >
    {children}
  </Box>
)

export const InputWithAdornment = forwardRef<
  HTMLInputElement,
  InputWithAdornmentProps
>(
  (
    {
      before,
      after,
      isBeforeClickable = false,
      isAfterClickable = false,
      ...rest
    },
    ref
  ) => {
    const inputStyles: ThemeUIStyleObject = {
      pl: before ? 6 : 4,
      pr: after ? 6 : 4,
    }
    const otherSx: ThemeUIStyleObject = rest.sx ?? {}
    return (
      <Flex sx={{ position: 'relative', alignItems: 'center' }}>
        {before && (
          <Adornment
            sx={{ left: 0, pl: 4, zIndex: 1 }}
            isClickable={isBeforeClickable}
          >
            {before}
          </Adornment>
        )}
        <Input
          ref={ref as any}
          sx={Object.assign(inputStyles, otherSx)}
          {...rest}
        />
        {after && (
          <Adornment sx={{ right: 0, pr: 4 }} isClickable={isAfterClickable}>
            {after}
          </Adornment>
        )}
      </Flex>
    )
  }
)
